export default {
  ADD_USER_MODIFIED_ATTRIBUTE: '@WS_EDITOR/DESIGN_AUTOMATION/ADD_USER_MODIFIED_ATTRIBUTE',
};
